export default __webpack_public_path__ + "static/media/image6.cf62bec7.jpg";